import React, { useState } from "react";
import { Button } from "../Button/Button";
import { useDictionaryContext } from "../../../context/dictionary/useDictionaryContext";
import { useSiteContext } from "../../../context/site/useSiteContext";
import { DICTIONARY_MAP } from "../../../carlsberg-headless/dictionary-map";
import {
  useClearRefinements,
  useRefinementList,
} from "react-instantsearch-hooks";

type PresetFilterProps = Record<string, unknown>;

const presetFiltersValues = {
  mostPopular: "Most Popular",
  oldestBottle: "Oldest Bottles",
  uniqueShapes: "Unique Shapes",
};

export const PresetFilters: React.FC<PresetFilterProps> = () => {
  const { refine: clearAll } = useClearRefinements();
  const { refine, items } = useRefinementList({
    attribute: "featured",
    limit: 1000,
  });

  const [featured, setFeatured] = useState<string | null>(null);

  const clickFeatured = (type: string) => {
    clearAll();
    if (featured === type) {
      setFeatured(null);
    } else {
      setFeatured(type);
      refine(type);
    }
  };

  const { get } = useDictionaryContext();
  const { currentCulture } = useSiteContext();
  return (
    <React.Fragment>
      <Button
        variant={
          items.find((i) => i.value === presetFiltersValues.mostPopular)
            ?.isRefined
            ? "greenSelected"
            : "green"
        }
        outline
        sx={{
          marginLeft: [0, 0, "auto"],
          mr: [0, 0, 1],
          width: ["100%", "33%", "auto"],
          mb: [1, 1, 0],
          borderRadius: 0,
        }}
        onClick={() => clickFeatured(presetFiltersValues.mostPopular)}
      >
        {get(DICTIONARY_MAP.kiosk.kiosk_filters_favourites, currentCulture)}
      </Button>
      <Button
        variant={
          items.find((i) => i.value === presetFiltersValues.oldestBottle)
            ?.isRefined
            ? "greenSelected"
            : "green"
        }
        outline
        sx={{ mr: [0, 0, 1], width: ["100%", "33%", "auto"], mb: [1, 1, 0], borderRadius: 0,}}
        onClick={() => clickFeatured(presetFiltersValues.oldestBottle)}
      >
        {get(DICTIONARY_MAP.kiosk.kiosk_filters_oldest, currentCulture)}
      </Button>
      <Button
        variant={
          items.find((i) => i.value === presetFiltersValues.uniqueShapes)
            ?.isRefined
            ? "greenSelected"
            : "green"
        }
        outline
        sx={{ width: ["100%", "33%", "auto"], mb: [1, 1, 0], borderRadius: 0,}}
        onClick={() => clickFeatured(presetFiltersValues.uniqueShapes)}
      >
        {get(DICTIONARY_MAP.kiosk.kiosk_filters_unique, currentCulture)}
      </Button>
    </React.Fragment>
  );
};
